import { Button } from 'components/ui'
import { useOnboarding } from 'context/onboarding-context'

const SampleToolLibrary = () => {
  const { handleUseSampleToolLibrary } = useOnboarding()

  return (
    <div className="flex h-40 min-h-40 w-full flex-1 flex-col items-center justify-center rounded-xl border border-gray-100 lg:w-1/2">
      <div className="flex flex-row flex-wrap items-center justify-center gap-x-4">
        <span className="text-lg leading-10 text-gray">or</span>
        <Button onClick={handleUseSampleToolLibrary} primary variant="large">
          Use a Sample Library
        </Button>
      </div>
    </div>
  )
}

export default SampleToolLibrary
